<template>
  <div>
    <div class="leave-calendar position-relative">
      <b-overlay :show="loading" rounded="sm" style="min-height:100px;">
        <b-card>
          <div class="legend">
            <div class="legend-item">
              Pending
            </div>
            <div class="legend-item">
              Approved
            </div>
          </div>
          <div class="select-plane">
            <b-row>
              <b-col md="3">
                <a-select
                  show-search
                  style="width: 100%;"
                  allow-clear
                  :value="projectId"
                  :filter-option="filterOption"
                  :placeholder="
                    $t('_components.placeholder.select') + 'Project'
                  "
                  @change="handleChangeProject"
                >
                  <a-select-option
                    v-for="item in projectsList"
                    :key="item.value"
                    :value="item.value"
                    :title="item.label"
                  >
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </b-col>
              <b-col md="3">
                <a-select
                  show-search
                  style="width: 100%;"
                  allow-clear
                  :value="vacationInfoId"
                  :filter-option="filterOption"
                  :placeholder="
                    $t('_components.placeholder.select') + 'Vacation'
                  "
                  @change="handleChange"
                >
                  <a-select-option
                    v-for="item in vacationDictOptions"
                    :key="item.value"
                    :value="item.value"
                    :title="item.label"
                  >
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </b-col>
              <b-col md="3">
                <tree-select
                  v-model="deptId"
                  show-search
                  allow-clear
                  style="width: 100%"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  :placeholder="
                    $t('_components.placeholder.select') + 'Department'
                  "
                  :tree-data="dictOptions"
                  :filter-tree-node="filterOption"
                  @change="onChange"
                />
              </b-col>
              <b-col md="3">
                <bForm-input v-model="staffName" @input="onInput" :placeholder="$t('_staff.labelLeaverecord.staffName')"></bForm-input>
              </b-col>
            </b-row>
          </div>
          <a-calendar @panelChange="onPanelChange" @change="change">
            <ul slot="dateCellRender" slot-scope="value" class="events">
              <li class="leaveName">
                {{
                  mapDicts[getDate(value)] &&
                    mapDicts[getDate(value)].holidayName
                }}
              </li>
              <template v-if="listData[getDate(value)]">
                <template v-for="(item, key) in listData[getDate(value)]">
                  <div :key="key" v-if="showLeave(item, value)">
                    <a-tooltip
                      placement="left"
                      :title="formatTipText(item, value)"
                    >
                      <li :class="[item.type]" class="leave-item">
                        {{ item.content }}
                      </li>
                    </a-tooltip>
                  </div>
                </template>
              </template>
            </ul>
            <template slot="monthCellRender" slot-scope="value">
              <div v-if="getMonthData(value)" class="notes-month">
                <section>{{ getMonthData(value) }}</section>
              </div>
            </template>
          </a-calendar>
        </b-card>
      </b-overlay>

      <!-- <div class="card shadow-none border-0 mb-0 rounded-0">
        <div class="card-body pb-0">
          <full-calendar
            ref="refCalendar"
            :options="calendarOptions"
            class="full-calendar"
          />
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import store from '@/store'
// import useCalendar from './useCalendar'
import { TreeSelect } from 'ant-design-vue'
import {
  BCard,
  BCardTitle,
  BCardSubTitle,
  BCardBody,
  BCollapse,
  BOverlay,
  BRow,
  BCol,
  BFormInput
} from 'bootstrap-vue'
import ElementComponent from '@/components/elementComponent.vue'
import { getDicts, flattenArray } from '@/components/components/utils'

import { getVacationRecordsByMonth } from '@/api/staff/vacation/index'
import moment from 'moment'

export default {
  components: {
    // FullCalendar,
    BCard,
    BOverlay,
    TreeSelect,
    BRow,
    BCol,
    BFormInput
    // ElementComponent,
  },
  data() {
    return {
      month: moment(new Date()).format('YYYY-MM'),
      mapDicts: {},
      deptId: null,
      staffName: null,
      vacationInfoId: undefined,
      projectId: undefined,
      loading: false,
      vacationDictOptions: [],
      dictOptions: [],
      projectsList: []
    }
  },
  computed: {
    listData() {
      const res = {}
      Object.keys(this.mapDicts).forEach((date) => {
        const item = this.mapDicts[date]
        res[date] = (item && item.leaveList) || []
      })
      return res
    },
  },
  created() {
    this.initDictOption()
    this.onInput = this.debounce(this.nameChange, 500)
  },
  mounted() {
    this.onload()
  },
  methods: {
    getListData(value) {
      let listData = []
      const currentDay = moment(value).format('YYYY-MM-DD')
      if (currentDay) {
        const day = moment(value).format('YYYY-MM-DD')
        listData = (this.mapDicts[day] && this.mapDicts[day].leaveList) || []
      }
      return listData
    },
    getDate(date) {
      return moment(date).format('YYYY-MM-DD')
    },
    getMonthData(value) {
      return ''
    },
    onPanelChange(value, mode) {
      // console.log(value, mode);
      this.month = moment(value).format('YYYY-MM')
      this.onload()
    },
    onChange(val1, val2) {
      this.onload()
    },
    handleChange(e) {
      this.vacationInfoId = e
      this.onload()
    },
    handleChangeProject(e) {
      this.projectId = e
      this.onload()
    },
    showLeave(item, date) {
      const obj = item.cc
      const week = this.getWeekday(date)
      const vacationName = item.vacationName
      let isShow = true
      if (week === 'Saturday') {
        if (obj.calculationType == 1) {
          // 2: 周六上午；4: 周六全天
          isShow = obj.workWeek == 2 || obj.workWeek == 4
        } else {
          isShow = true
        }
      } else if (week === 'Sunday') {
        isShow = false
      } else {
        isShow = true
      }
      return isShow
    },
    renderLeaveName(value) {},
    formatTipText(item, date) {
      console.log(item, date)
      const obj = item.cc
      const week = this.getWeekday(date)
      const vacationName = item.vacationName
      let dayType = ''

      /*

      calculationType: 1 ：工作日计算  2：自然日计算
      workWeek:1:5天工作制度  2:5.5天周六上午  3:NA  4:周六全天


      */
      if (week === 'Saturday') {
        if (obj.calculationType == 1) {
          // 2 周六上午，4 周六全天
          dayType = obj.workWeek == 2 ? 'AM' : 'FULL DAY'
        } else {
          dayType = 'FULL DAY'
        }
      } else if (week === 'Sunday') {
        dayType = 'FULL DAY'
      } else {
        if (obj.leaveUnit == 1) {
          dayType = 'FULL DAY'
        } else if (obj.leaveUnit == 0.5) {
          dayType = obj.leavePeriod == 1 ? 'AM' : 'PM'
        } else {
          dayType = 'FULL DAY'
        }
      }
      return `${vacationName} / ${dayType}`
    },
    getWeekday(e) {
      // 创建一个 Moment 对象
      const date = moment(e)
      // 获取星期几，返回英文名称
      return date.format('dddd') // 'dddd' 返回完整的星期几名称
    },
    onload() {
      this.loading = true
      const mapDicts = {}
      getVacationRecordsByMonth({
        month: this.month,
        deptId: this.deptId,
        vacationInfoId: this.vacationInfoId,
        projectId: this.projectId,
        staffName: this.staffName
      }).then((res) => {
        const { data } = res.data
        this.loading = false
        data.forEach((el) => {
          if (
            el.date &&
            ((el.leaveRecordVOS && el.leaveRecordVOS.length) || el.holidayName)
          ) {
            const day = moment(el.date).format('YYYY-MM-DD')
            const leaveList = el.leaveRecordVOS.map((item) => ({
              type: item.status === 2 ? 'success' : 'warning',
              content: item.staffName,
              vacationName: item.vacationName || '',
              cc: item,
            }))
            mapDicts[day] = {
              holidayName: el.holidayName && el.holidayName,
              leaveList,
            }
          }
        })
        this.mapDicts = mapDicts
        this.$forceUpdate()
      })
    },
    initDictOption(e, notChangeData) {
      const toStringVal = ''
      const option = {
        onlySelectChildren: true,
        type: 'select',
        dictCode: 'dept',
        formOption: {
          type: 'select',
          dictCode: 'dept',
          span: 3,
        },
      }

      const vacationOption = {
        type: 'select',
        dictCode: 'vacationInfo',
        formOption: {
          type: 'select',
          dictCode: 'vacationInfo',
          span: 3,
        },
      }
      const projects = {
        type: 'project',
        dictCode: 'project',
        formOption: {
          type: 'select',
          dictCode: 'project',
          span: 3,
        },
      }
      getDicts(option).then((res) => {
        console.log('八嘎', res);
        this.dictOptions = res
        if (option.onlySelectChildren) {
          // console.log(this.dictOptions);
        }
        this.loading = false
      })
      
      getDicts(vacationOption).then((res) => {
        this.vacationDictOptions = res
        this.loading = false
      })
      getDicts(projects).then((res) => {
        this.projectsList = res
        this.loading = false
      })
    },
    filterOption(input, option) {
      const CIndexOf = (str1, str2) =>
        str1.toUpperCase().includes(str2.toUpperCase())
      const { title } = option.componentOptions.propsData
      return CIndexOf(title, input)
    },
    change(date) {
      this.month = moment(date).format('YYYY-MM')
    },
    select(date) {
      this.month = moment(date).format('YYYY-MM')
    },
    debounce(fn, delay = 300) {
      let timer = null
      return function (...args) {
        clearTimeout(timer)
        timer = setTimeout(() => {
          fn.apply(this, args)
        }, delay)
      }
    },
    nameChange(){
      this.onload()
    }
  },
}
</script>

<style lang="scss">
// @import "@core/scss/vue/apps/calendar.scss";
.leave-calendar {
  .ant-radio-group {
    display: none;
  }
  .ant-fullcalendar-fullscreen .ant-fullcalendar-date {
    height: 222px;
  }
  .ant-fullcalendar td {
    height: 220px;
    .ant-fullcalendar-content {
      height: 192px;
    }
  }
}
</style>

<style lang="scss" scoped>
.events {
  list-style: none;
  margin: 0;
  padding: 0;
}
.events .ant-badge-status {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
}
.notes-month {
  text-align: center;
  font-size: 28px;
}
.notes-month section {
  font-size: 28px;
}
.legend {
  width: 100px;
  position: absolute;
  left: 70px;
  top: 25px;
  &-item {
    width: 180px;
    position: relative;
    margin-bottom: 5px;
    &::after {
      content: '';
      position: absolute;
      left: -30px;
      width: 20px;
      height: 20px;
    }
    &:nth-child(1) {
      &::after {
        background: yellow;
      }
    }
    &:nth-child(2) {
      &::after {
        background: green;
      }
    }
  }
}
.select-plane {
  width: 800px;
  position: absolute;
  right: 230px;
  top: 25px;
}
.leaveName {
  color: red;
  position: absolute;
  top: 0;
  transform: translateY(5px);
}
.leave-item {
  margin-bottom: 5px;
}
ul {
  li.success {
    background: green;
    color: #fff;
  }
  li.warning {
    background: yellow;
  }
}
</style>
